import styled from 'styled-components';

const Copyright = styled.div<{ fontWeight: string; color: string; lineHeight: string }>`
  font-weight: ${(props) => props.fontWeight};
  color: ${(props) => props.color};
  font-size: 14px;
  line-height: ${(props) => props.lineHeight};
  padding: 0 !important;
  a {
    display: inline;
    text-decoration: underline;
    font-size: 14px;
    font-weight: ${(props) => props.fontWeight};
    color: ${(props) => props.color};
    margin: 0;
    padding: 8px;
  }

  a:hover {
    color: ${(props) => props.color};
    opacity: 0.6;
  }
`;

export default Copyright;
